// extracted by mini-css-extract-plugin
export default {"dialogList":"deactivate-user_dialogList__X--iU"};